@if (loadingState$ | async; as state) {
	@if (state.isLoading) {
		<div class="loading-overlay">
			<div class="loading-content">
				<mat-spinner diameter="40"></mat-spinner>
				<p class="loading-text">{{ state.message }}</p>
				@if (state.hint) {
					<p class="loading-hint">{{ state.hint }}</p>
				}
			</div>
		</div>
	}
}
